<template>
    <!--Loader inicial del modo nativo (mientras carga la config/agente)-->
    <div v-if="!showchat && widget && widget.layout === 'native'" class="widget_chat widget_chat_native widget_native_loading" :style="nativeVars">
        <div class="widget_native_spinner"></div>
    </div>
    <div v-if="showchat" :class="`widget_chat ${widgetChat}`" :style="nativeVars">
        <!--Banner lateral (modo nativo, estilo itel): imagen a la izquierda del chat-->
        <div v-if="widget.layout === 'native' && widget.native_image" class="widget_native_side">
            <img :src="widget.native_image" alt="">
        </div>
        <div v-if="viewForm" class="widget_chat_formulario">
            <div class="widget_chat_formulario_header">
                <div v-show="widget.is_fullscreen == 'false' || is_mobile" class="widget_chat_window_header_close"
                    style="margin-left: auto;">
                    <svg style="color:#000" @click="closeChat" width="24" height="24" viewBox="0 0 24 24"
                        stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round"
                        stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M6 9l6 6l6 -6"></path>
                    </svg>
                </div>
            </div>
            <div class="widget_chat_formulario_body">
                <form class="send_form_user" @submit.prevent="sendFormUser">
                    <div class="widget_chat_formulario_body_title">
                        <img :style="'background:' + widget.color_header_background" :src="header.avatar" alt="">
                        <h3>{{ header.header_content_text }}</h3>
                    </div>
                    <div v-if="widget?.translations[language]?.form_message"
                        class="widget_chat_formulario_body_message">
                        <p>{{ widget.translations[language].form_message }}</p>
                    </div>
                    <div class="widget_chat_formulario_body_input"
                        v-if="widget.form_name == 'required' || widget.form_name == 'show'">
                        <input id="input_name" :required="widget.form_name == 'required' ? true : false" type="text"
                            v-model="form_name" placeholder="">
                        <label for="input_name">{{ widget?.translations?.[language]?.enter_name || 'Name' }}</label>
                        <span v-if="widget.form_name == 'required'"
                            class="widget_chat_formulario_body_input_asterisk">*</span>
                    </div>
                    <div class="widget_chat_formulario_body_input"
                        v-if="widget.form_email == 'required' || widget.form_email == 'show'">
                        <input id="input_email" :required="widget.form_email == 'required' ? true : false" type="email"
                            v-model="form_email" placeholder="">
                        <label for="input_email">{{ widget?.translations?.[language]?.enter_email || 'Email' }}</label>
                        <span v-if="widget.form_email == 'required'"
                            class="widget_chat_formulario_body_input_asterisk">*</span>
                    </div>
                    <div class="widget_chat_formulario_body_input"
                        v-if="widget.form_phone == 'required' || widget.form_phone == 'show'">
                        <v-phone-input v-model="phone" :label="widget?.translations?.[language]?.enter_phone || 'Phone'"
                            countryLabel="" />
                        <span v-if="widget.form_phone == 'required'"
                            class="widget_chat_formulario_body_input_asterisk">*</span>
                    </div>
                    <div class="widget_chat_formulario_body_politicas" v-if="widget.form_policy != ''">
                        <switchPoliticas :color="widget.color_primary" />
                        <label for="cbx">
                            <span v-html="processedPolicyText"></span>
                        </label>
                    </div>
                    <div class="widget_chat_formulario_body_submit">
                        <button type="submit"
                            :style="`background: ${widget.color_primary}; color: ${widget.color_message_text}`">{{
                                widget?.translations?.[language]?.start_chat || 'Start Chat' }}</button>
                    </div>
                </form>
            </div>
        </div>
        <div v-if="!viewForm" :class="`widget_chat_window ${sinBorderWindows}`">
            <div class="widget_chat_window_header" v-show="widget.hide_bar_header == 'false'"
                :style="`background: ${widget.color_header_background};`">
                <div v-if="header.header_type == 'avatar_title' || header.header_type == 'avatar_images' || header.header_type == 'only_avatar'"
                    class="widget_chat_window_header_avatar">
                    <img :src="header.avatar" alt="Avatar">
                    <div v-if="on_agente" class="avatar_online"></div>
                </div>
                <div class="widget_chat_window_header_title"
                    :style="{ width: (['avatar_title', 'avatar_images', 'only_avatar'].includes(header.header_type) ? 'calc(100% - 98px)' : 'calc(100% - 58px)') }">
                    <h3 v-if="header.header_type == 'avatar_title' || header.header_type == 'only_title' || on_agente"
                        :style="`color: ${widget.color_header_text};`">
                        {{ header.header_content_text }}
                    </h3>
                    <div v-if="(header.header_type == 'avatar_images' || header.header_type == 'only_image') && !on_agente"
                        class="widget_chat_formulario_header_title_img">
                        <img :src="widget.header_content_img" alt="">
                    </div>
                </div>
                <div class="widget_chat_window_header_actions">
                    <div @click="resetConversacion" class="widget_chat_window_header_tools_item icon_reset">
                        <svg :style="`color: ${widget.color_header_text};`" width="24" height="24" viewBox="0 0 24 24"
                            stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round"
                            stroke-linejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"></path>
                            <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"></path>
                        </svg>
                    </div>
                    <div @click="closeChat" v-show="(widget.is_fullscreen == 'false' || is_mobile)" v-if="showClose"
                        class="widget_chat_window_header_tools_item icon_close">
                        <svg :style="`color: ${widget.color_header_text};`" width="24" height="24" viewBox="0 0 24 24"
                            stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round"
                            stroke-linejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M6 9l6 6l6 -6"></path>
                        </svg>
                    </div>
                </div>
            </div>
            <!--Contenedor de los chats-->
            <div id="chatBody" :style="{
                height: `calc(100% - ${calculateHeight})`,
                backgroundColor: widget.fondo,
                backgroundImage: (widget?.background_image && widget.background_image !== '') ? `url('${widget.background_image}')` : 'none',
                backgroundSize: 'cover',
                backgroundPosition: 'top center',
                backgroundRepeat: 'no-repeat'
            }" v-on:click="handleDynamicItemClick($event)" v-on:scroll="handleScroll" class="widget_chat_window_body">
                <!--Landing hero (modo nativo): título y subtítulo encima del input.
                    Los topics van DEBAJO del input (ver tras el footer). Sin saludo del bot.-->
                <transition name="lv-fade">
                    <div v-if="widget.layout === 'native' && widget.native && widget.native.hero !== false && !convStarted && (widget.native.hero_title || widget.native.hero_subtitle)"
                        class="widget_native_hero_head">
                        <h2 v-if="widget.native.hero_title">{{ widget.native.hero_title }}</h2>
                        <p v-if="widget.native.hero_subtitle">{{ widget.native.hero_subtitle }}</p>
                    </div>
                </transition>
                <div class="widget_row_message" v-for="(message, index) in messages" :id="'message-' + index"
                    :key="index" v-html="message.message"></div>
                <!--Mesaje de finalizacion de mensaje-->
                <div class="widget_row_message widget_row_message_end" v-if="ended_chat">
                    <div class="widget_message_end_button">
                        <button :style="`border-color: ${widget.color_primary}; color: ${widget.color_primary}`"
                            @click="resetConversacion">{{ widget?.translations?.[language]?.start_chat || 'Start Chat'
                            }}</button>
                    </div>
                </div>
                <!--Mensaje de espera-->
                <div class="widget_row_message widget_row_message_loader" v-if="loader && chat?.status !== 'queue' && chat?.status !== 'human'">
                    <div class="widget_message widget_message_bot widget_message_loader_inner">
                        <!-- Leyenda contextual cuando el agente usa una tool (status del stream) -->
                        <span v-if="statusLabel" class="widget_status_label">{{ statusLabel }}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                            style="margin: 10px;display: block;shape-rendering: auto;width: 43px;height: 20px;"
                            viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                            <circle cx="0" cy="44.1678" r="15" fill="#3d3e45">
                                <animate attributeName="cy" calcMode="spline"
                                    keySplines="0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5" repeatCount="indefinite"
                                    values="57.5;42.5;57.5;57.5" keyTimes="0;0.3;0.6;1" dur="1s" begin="-0.6s">
                                </animate>
                            </circle>
                            <circle cx="45" cy="43.0965" r="15" fill="#3d3e45">
                                <animate attributeName="cy" calcMode="spline"
                                    keySplines="0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5" repeatCount="indefinite"
                                    values="57.5;42.5;57.5;57.5" keyTimes="0;0.3;0.6;1" dur="1s"
                                    begin="-0.39999999999999997s"></animate>
                            </circle>
                            <circle cx="90" cy="52.0442" r="15" fill="#3d3e45">
                                <animate attributeName="cy" calcMode="spline"
                                    keySplines="0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5" repeatCount="indefinite"
                                    values="57.5;42.5;57.5;57.5" keyTimes="0;0.3;0.6;1" dur="1s"
                                    begin="-0.19999999999999998s"></animate>
                            </circle>
                        </svg>
                    </div>
                </div>
                <!--Bottom para bajar la conversacion-->
                <div class="action_to_bottom" v-on:click="scrollBottom()">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round"
                        class="icon icon-tabler icons-tabler-outline icon-tabler-chevron-down">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M6 9l6 6l6 -6" />
                    </svg>
                </div>
            </div>
            <!--Footer del widget-->
            <div class="widget_chat_window_footer" v-show="widget.hide_bar_write == 'false'">
                <form @submit.prevent="sendFormMessage">
                    <div class="widget_form_message">
                        <textarea id="inputMessage" @input="resizeTextarea" @keydown.enter.prevent="sendFormMessage"
                            ref="textarea" autocomplete="off"
                            :placeholder="widget?.translations?.[language]?.write_message || 'Write a message'"></textarea>
                    </div>
                    <div class="widget_form_submit">
                        <label v-if="allowAttachFile" for="messageMedia" style="padding:0;padding-top:10px;">
                            <svg v-if="!loadingClip" class="loading" version="1.1" id="L3" x="0px" y="0px"
                                viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
                                <circle fill="none" stroke="#adbbdf" stroke-width="4" cx="50" cy="50" r="44"
                                    style="opacity:0.5;" />
                                <circle fill="#007bff" stroke="#007bff" stroke-width="3" cx="8" cy="54" r="6">
                                    <animateTransform attributeName="transform" dur="2s" type="rotate" from="0 50 48"
                                        to="360 50 52" repeatCount="indefinite" />
                                </circle>
                            </svg>
                            <svg v-if="loadingClip" viewBox="0 0 64 80" x="0px" y="0px">
                                <path
                                    d="M10.5,57a18.62,18.62,0,0,1,.17-25.87L35.61,5.6a13.31,13.31,0,0,1,19.12,0,13.85,13.85,0,0,1,0,19.3L33,47.12A8.88,8.88,0,0,1,20.13,47a9.22,9.22,0,0,1,.18-12.72L37.4,16.82a1.9,1.9,0,0,1,2.69,0l2.72,2.66a1.9,1.9,0,0,1,0,2.69L25.75,39.6a1.61,1.61,0,0,0-.08,2.18,1.27,1.27,0,0,0,1.87,0L49.28,19.57a6.21,6.21,0,0,0,0-8.65,5.69,5.69,0,0,0-8.22,0l-25,25.52A11,11,0,0,0,16,51.7a10.14,10.14,0,0,0,14.63,0L51.07,30.8a1.9,1.9,0,0,1,2.69,0l2.72,2.66a1.9,1.9,0,0,1,0,2.69L36.05,57.05A17.75,17.75,0,0,1,10.5,57Z"
                                    fill="#aaa" />
                            </svg>
                            <input id="messageMedia" @change="sendFormMessageMedio" type="file"
                                accept="image/*,audio/*,video/*,.pdf" style="display:none">
                        </label>
                        <button type="submit">
                            <svg viewBox="0 0 24 30" fill="none" x="0px" y="0px">
                                <path
                                    d="M22.1012 10.5616L2.75289 1.12336C2.58649 1.04219 2.40377 1 2.21862 1C1.5456 1 1 1.5456 1 2.21862V2.25379C1 2.41731 1.02005 2.58022 1.05971 2.73886L2.91568 10.1627C2.96637 10.3655 3.13782 10.5153 3.34554 10.5384L11.5031 11.4448C11.786 11.4762 12 11.7153 12 12C12 12.2847 11.786 12.5238 11.5031 12.5552L3.34554 13.4616C3.13782 13.4847 2.96637 13.6345 2.91568 13.8373L1.05971 21.2611C1.02005 21.4198 1 21.5827 1 21.7462V21.7814C1 22.4544 1.5456 23 2.21862 23C2.40377 23 2.58649 22.9578 2.75289 22.8766L22.1012 13.4384C22.6511 13.1702 23 12.6119 23 12C23 11.3881 22.6511 10.8298 22.1012 10.5616Z"
                                    :fill="widget.color_primary" />
                            </svg>
                        </button>
                    </div>
                </form>
                <div class="widget_chat_window_footer_legends">
                    <a target="_blank" href="https://lovi.ai/">
                        <img :src="icono_lovi" alt="Icono Lovi">
                        Generated by lovi.ai
                    </a>
                </div>
            </div>
            <!--Check de políticas (modo nativo): obligatorio antes del primer envío si hay form_policy-->
            <transition name="lv-fade">
                <div v-if="widget.layout === 'native' && !convStarted && widget.form_policy && widget.form != 'true'"
                    class="widget_native_policy" :class="{ widget_native_policy_error: policyError }">
                    <input type="checkbox" id="lv-native-policy" v-model="policyAccepted" @change="policyError = false">
                    <label for="lv-native-policy" v-html="processedPolicyText"></label>
                </div>
            </transition>
            <!--Topics del hero (modo nativo): DEBAJO del input-->
            <transition name="lv-fade">
                <div v-if="widget.layout === 'native' && widget.native && widget.native.hero !== false && !convStarted && widget.native.topics && widget.native.topics.length"
                    class="widget_native_topics widget_native_topics_below">
                    <button v-for="(t, i) in widget.native.topics" :key="i" type="button"
                        class="widget_native_topic" @click="sendTopic(t)">{{ t }}</button>
                </div>
            </transition>
            <!--Branding del modo nativo: SOLO en hero, DESPUÉS del input y de los topics
                (queda debajo de los topics si los hay, o debajo del input si no). En chat desaparece.-->
            <transition name="lv-fade">
                <div v-if="widget.layout === 'native' && widget.native && widget.native.show_branding && !convStarted"
                    class="widget_native_branding">
                    <a target="_blank" href="https://lovi.ai/">
                        <img :src="icono_lovi" alt="Icono Lovi"> Generated by lovi.ai
                    </a>
                </div>
            </transition>
            <div class="brand_botslovers" v-if="widget.hide_bar_write == 'true'">
                <a target="_blank" href="https://lovi.ai/">
                    <img :src="icono_lovi" alt="Icono Lovi">
                    Generated by lovi.ai
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import DOMPurify from 'dompurify';
import helperFunctions from "./services/helperFunctions.js";
import switchPoliticas from "./components/switchPoliticas.vue";
import icono_lovi from '@/assets/images/icono_lovi.png';
import { createClient } from '@supabase/supabase-js';
//Exportamos el modulo
export default {
    name: 'App',
    components: {
        switchPoliticas
    },
    data() {
        return {
            supabase_realtime: false,
            session_token: false,
            session_expires_at: 0,
            access_key: false,
            id_widget: false,
            id_user: false,
            widget: this.widget,
            company: this.company,
            name_company: this.name_company,
            language: "en",
            agent: false,
            info_user: false,
            data_collection: false,
            user: false,
            chat: false,
            init_bot: true,
            alturaChatbody: false,
            header: {},
            showchat: false,
            showChatWindow: false,
            form_name: '',
            form_email: '',
            messages: [],
            loadingClip: true,
            event: false,
            contexto_extra: [],
            medidasTextarea: 49,
            is_mobile: false,
            site_web: false,
            on_agente: false,
            subscription_message: false,
            subscription_chat: false,
            ended_chat: false,
            // Valor de config de hide_bar_write antes de que cerrar_chat() ocultase la
            // barra de escritura. Al reiniciar la conversación hay que devolverlo.
            hide_bar_write_original: null,
            icono_lovi,
            loader: false,
            // Leyenda contextual mostrada dentro del loader cuando el agente está
            // usando una tool (p.ej. "Consultando la base de conocimiento…"). Se
            // setea con el evento `status` del stream y se limpia al llegar texto.
            statusLabel: "",
            phone: '',
            currentStreamIndex: null,
            currentStreamMid: null,
            // Flag por turno: true cuando el INSERT de realtime ya pinto el mensaje
            // final del bot. Mientras este activo, el preview SSE deja de renderizar
            // para no duplicar (carrera SSE vs realtime, en cualquier orden).
            streamArrivedViaRealtime: false,
            // Flag por turno: true en cuanto el widget ha PINTADO algo del bot en
            // este turno, venga del preview SSE o del INSERT de realtime. Es lo que
            // permite detectar el "turno mudo" (`stream_ia` apagado: el backend
            // resuelve la IA dentro del POST y el SSE no trae ni un chunk) y
            // reconciliar contra `/messages` en vez de dejar la respuesta invisible
            // hasta que el visitante recarga.
            turnoPintado: false,
            // Turnos en vuelo que encendieron la burbuja de "escribiendo" desde el
            // widget (modo sin streaming). Es un CONTADOR, no un booleano: en una
            // rafaga hay varios POST abiertos y solo el ultimo en cerrar debe
            // apagarla (ver encenderLoaderLocal/apagarLoaderLocal).
            turnosLoaderLocal: 0,
            showClose: true,
            // Modo nativo: false = mostramos el landing "hero"; true = ya hay conversación
            convStarted: false,
            // Check de políticas del modo nativo (si el widget tiene form_policy configurada)
            policyAccepted: false,
            policyError: false,
            // Native+hero con form:true → el form aparece como gate al iniciar; aquí guardamos
            // el estado del gate y el mensaje pendiente que se enviará tras completar el form.
            nativeFormGate: false,
            pendingNativeMessage: null,
        };
    },
    methods: {
        //Construye URL al edge function /widget/<path>
        widget_url(path) {
            return `${process.env.VUE_APP_SUPABASE_URL}functions/v1/widget${path}`;
        },
        //Carga las fuentes del modo nativo (Inter + Source Serif 4) una sola vez
        injectNativeFonts() {
            if (document.getElementById('lv-native-fonts')) return;
            const link = document.createElement('link');
            link.id = 'lv-native-fonts';
            link.rel = 'stylesheet';
            link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Source+Serif+4:opsz,wght@8..60,400;8..60,600&display=swap';
            document.head.appendChild(link);
        },
        //Pide token de sesion al backend (JWT efimero solo para realtime).
        //Renueva si esta expirado o falta menos de 1 minuto.
        async ensure_session_token() {
            const now = Math.floor(Date.now() / 1000);
            // Renueva si quedan <5min (el keep-alive corre cada 5min).
            if (this.session_token && this.session_expires_at - now > 300) {
                return this.session_token;
            }
            if (!this.access_key || !this.id_widget || !this.id_user) {
                console.error('[Error] Faltan credenciales para session token');
                return false;
            }
            try {
                const res = await fetch(this.widget_url('/session'), {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        access_key: this.access_key,
                        id_widget: this.id_widget,
                        channel_id: this.id_user,
                    }),
                });
                if (!res.ok) {
                    console.error('[Error] /widget/session', res.status);
                    return false;
                }
                const data = await res.json();
                if (!data?.token) return false;
                this.session_token = data.token;
                this.session_expires_at = now + (data.expires_in || 900);
                if (this.supabase_realtime?.realtime?.setAuth) {
                    this.supabase_realtime.realtime.setAuth(this.session_token);
                }
                return this.session_token;
            } catch (e) {
                console.error('[Error] ensure_session_token:', e);
                return false;
            }
        },
        //Crea cliente Supabase usado SOLO para realtime y storage.
        //RLS via chats_widget / messages_widget filtra por claims del JWT.
        async create_cliente_realtime() {
            // Idempotente: si ya hay cliente, no crear otro.
            // Crear varios genera "Multiple GoTrueClient instances" y suscripciones huerfanas.
            if (this.supabase_realtime) return true;
            const token = await this.ensure_session_token();
            if (!token) return false;
            this.supabase_realtime = createClient(
                process.env.VUE_APP_SUPABASE_URL,
                process.env.VUE_APP_SUPABASE_ANON_KEY,
                {
                    global: { headers: { Authorization: `Bearer ${token}` } },
                }
            );
            // Aplicar el JWT al websocket de realtime ANTES de suscribir.
            // Sin esto, el websocket arranca con anon-key (sin claims company_id/channel_id)
            // y las policies messages_widget/chats_widget rechazan cada fila => 0 payloads.
            if (this.supabase_realtime?.realtime?.setAuth) {
                this.supabase_realtime.realtime.setAuth(token);
            }
            return true;
        },
        //GET a un endpoint /widget/* con los params de sesion.
        async widget_get(path, extra = {}) {
            const params = new URLSearchParams({
                access_key: this.access_key,
                id_widget: this.id_widget,
                channel_id: this.id_user,
                ...extra,
            });
            const res = await fetch(`${this.widget_url(path)}?${params}`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            });
            if (!res.ok) {
                const text = await res.text().catch(() => '');
                console.error(`[Error] GET ${path}`, res.status, text);
                return null;
            }
            return res.json();
        },
        // P0-3: ruta del objeto dentro de uploads a partir de una URL pública legacy.
        extractUploadsPath(url) {
            if (typeof url !== 'string') return null;
            const m = url.match(/\/public\/(?:chat-media|uploads)\//);
            if (!m) return null;
            let p = url.slice(m.index + m[0].length).split('?')[0].split('#')[0];
            try { p = decodeURIComponent(p); } catch (e) { /* dejar tal cual */ }
            return p || null;
        },
        // P0-3: firma (in-place) los adjuntos de un content de mensaje entrante por
        // realtime, con el cliente de sesión (bucket privado -> la url pública no carga).
        async signMessageAttachments(content) {
            const client = this.supabase_realtime;
            if (!content || typeof content !== 'object' || !client) return;
            const signOne = async (obj) => {
                if (!obj || !obj.url) return;
                const path = obj.storage_path || this.extractUploadsPath(obj.url);
                if (!path) return;
                try {
                    const { data } = await client.storage.from('chat-media').createSignedUrl(path, 3600);
                    if (data?.signedUrl) obj.url = data.signedUrl;
                } catch (e) { /* fallback a la url original */ }
            };
            await signOne(content.custom_multimedia);
            const msg = content.message;
            if (msg && typeof msg === 'object') {
                if (Array.isArray(msg.attachments)) {
                    for (const att of msg.attachments) {
                        await signOne(att);
                        if (att && att.payload) await signOne(att.payload);
                    }
                }
                if (msg.attachment && msg.attachment.payload) await signOne(msg.attachment.payload);
            }
        },
        //Obtenemos la data de la recoleccion de data
        async get_data_collection() {
            let parent = this;
            return new Promise((resolve) => {
                let data_user = { 'tipo_peticion': 'data_collection' };
                this.sendIframe(data_user);
                this.bindEvent(window, 'message', function (e) {
                    let data = e.data;
                    if (data.tipo == "data_collection") {
                        parent.data_collection = data.data_collection;
                        resolve();
                    }
                });
            });
        },
        //Obtenemos data de los agents
        async get_data_agent() {
            this.agent = this.widget.agent;
        },
        //Obtenemos data del usuario via /widget/user (polling hasta que aparezca)
        async get_data_user(cargarMensajes = true) {
            return new Promise((resolve, reject) => {
                const tryFetch = async () => {
                    try {
                        const data = await this.widget_get('/user');
                        if (data?.user) {
                            this.user = data.user;
                            await this.get_data_chat(cargarMensajes);
                            return resolve();
                        }
                        setTimeout(tryFetch, 1000);
                    } catch (err) {
                        console.error('Error en get_data_user:', err);
                        reject(err);
                    }
                };
                tryFetch();
            });
        },
        
        //Obtenemos data del chat del usuario via /widget/chat
        async get_data_chat(cargarMensajes = true) {
            // Loop secuencial: solo UNA peticion en vuelo a la vez.
            // El setInterval previo disparaba multiples peticiones en paralelo,
            // y todas las que recibian data.chat ejecutaban create_cliente_realtime
            // y las suscripciones, creando canales duplicados que se ciclaban
            // CLOSED/SUBSCRIBED y perdian eventos en el medio.
            for (;;) {
                let data;
                try {
                    data = await this.widget_get('/chat', { user_id: this.user.id });
                } catch (error) {
                    console.error('Error en get_data_chat:', error);
                    await new Promise((r) => setTimeout(r, 1000));
                    continue;
                }
                if (data?.chat) {
                    this.chat = data.chat;
                    //Guardamos los datos del agent y chat id
                    this.sendIframe({
                        'tipo_peticion': 'save_customer',
                        'info_user': {
                            ...this.info_user,
                            'agent_id': this.chat.agent_id,
                            'chat_id': this.chat.id,
                        }
                    });
                    // Si el cliente de realtime no se pudo crear (p.ej. el token de
                    // sesion no llego), NO abortamos la carga: sin realtime no hay push
                    // de mensajes nuevos, pero la conversacion se pinta igual. Antes se
                    // ignoraba este false y listen_chat() reventaba con
                    // "supabase_realtime.channel is not a function", matando la carga
                    // entera y dejando el spinner encendido.
                    const realtime_ok = await this.create_cliente_realtime();
                    if (realtime_ok) {
                        await this.listen_chat();
                    } else {
                        console.error('[RT] sin cliente de realtime: se carga la conversacion sin push');
                    }
                    // Se llama SIEMPRE: `cargarMensajes = false` solo evita el
                    // repintado, nunca la suscripcion de realtime (ver
                    // get_data_messages). Saltarse la llamada entera dejaba el chat
                    // mudo.
                    await this.get_data_messages(cargarMensajes);
                    return;
                }
                await new Promise((r) => setTimeout(r, 1000));
            }
        },
        //Obtenemos los mensajes del chat via /widget/messages
        /**
         * @param {boolean} pintar  false = NO repintar la conversacion, pero SI
         *   dejar la suscripcion de realtime montada.
         *
         * 🔴 Las dos cosas van juntas en esta funcion y NO son separables desde
         * fuera: saltarsela entera para evitar el repintado deja el chat sin
         * `listen_messages()`, o sea sin push de mensajes nuevos. Es justo lo que
         * paso al arreglar el primer mensaje: se dejo de repintar (bien) pero
         * tambien de suscribir (mal), y la respuesta no aparecia nunca en vez de
         * aparecer tarde.
         */
        async get_data_messages(pintar = true) {
            if (!pintar) {
                // Sin repintar, pero la suscripcion es obligatoria.
                if (this.supabase_realtime) {
                    await this.listen_messages();
                }
                return;
            }
            const data = await this.widget_get('/messages', { chat_id: this.chat.id });
            const messages = data?.messages ?? [];
            if (messages.find(element => element.sender_type == "agent")) {
                this.showLoader(false);
            }
            let messages_aux = [];
            //Validamos si existe el welcome. En modo nativo NO se muestra el saludo del bot
            //(el hero hace de bienvenida), igual que en mounted.
            let welcome = this.widget?.layout === 'native' ? '' : this.returnWelcome();
            if (welcome != '') {
                messages_aux.push({
                    message: welcome,
                    created_at: this.chat?.created_at || messages?.[0]?.created_at || new Date(0).toISOString(),
                });
            }
            //Verificacion de slider
            let init_slider = false;
            for (let message of messages) {
                let messageInsert = helperFunctions.buildMensajeWeb(message.content.message, this.widget, message);
                //Si tiene swiper-container, inicializamos el slider
                if (messageInsert.includes('swiper-container')) {
                    init_slider = true;
                }
                messages_aux.push({
                    message: messageInsert,
                    created_at: message.created_at,
                    id: message.id,
                });
            }
            // Orden cronologico estable. En la carga inicial TODOS los created_at vienen
            // del servidor (mismo reloj), asi que ordenar aqui evita que el backend los
            // devuelva agrupados/desordenados. Se usa el id como desempate.
            messages_aux.sort((a, b) => {
                const diff = this.toTimestamp(a.created_at) - this.toTimestamp(b.created_at);
                if (diff !== 0) return diff;
                // Los id son UUID: restar daba NaN (desempate inservible). Comparar como string.
                const ai = a.id ?? '', bi = b.id ?? '';
                return ai < bi ? -1 : ai > bi ? 1 : 0;
            });
            this.messages = messages_aux;
            this.scrollBottom();
            if (init_slider) {
                this.initSlider();
            }
            // Misma guarda que en get_data_chat: listen_messages tambien usa
            // supabase_realtime, y sin cliente lanzaria justo despues de haber
            // pintado los mensajes.
            if (this.supabase_realtime) {
                await this.listen_messages();
            }
        },
        //obtenemos data del cliente
        get_data_cliente() {
            let parent = this;
            return new Promise((resolve) => {
                let data_user = { 'tipo_peticion': 'get_customer' };
                this.sendIframe(data_user);
                this.bindEvent(window, 'message', function (e) {
                    let data = e.data;
                    if (data.tipo == "get_customer") {
                        // Read language from message
                        if (data?.language && data.language != "undefined") {
                            parent.language = data.language;
                        }

                        // Read showClose from message
                        parent.showClose = data.showClose;

                        // Credenciales para los endpoints /widget/*
                        if (data?.access_key) parent.access_key = data.access_key;
                        if (data?.id_widget) parent.id_widget = data.id_widget;

                        parent.id_user = data.info_user.id;
                        (data?.info_user) ? parent.info_user = data.info_user : parent.info_user = {};
                        if (data?.source) {
                            parent.info_user.source = data.source;
                        }
                        if (data.mobile == 'on') {
                            parent.is_mobile = true;
                            parent.medidasTextarea = 52;
                        }
                        if (data?.contexto_extra && data.contexto_extra.length > 0) {
                            parent.contexto_extra = data.contexto_extra;
                        }
                        resolve();
                    }
                });
            });
        },
        //Cerramos el chat
        closeChat() {
            let data_user = { 'tipo_peticion': 'close' };
            this.sendIframe(data_user);
        },
        //Cierra las suscripciones de realtime que queden vivas.
        async cerrar_suscripciones() {
            if (this.supabase_realtime) {
                for (const key of ['subscription_chat', 'subscription_message']) {
                    if (!this[key]) continue;
                    try {
                        await this.supabase_realtime.removeChannel(this[key]);
                    } catch (e) {
                        console.error(`[RT] error al remover ${key} en el reinicio`, e);
                    }
                }
            }
            this.subscription_chat = false;
            this.subscription_message = false;
        },
        //Reiniciamos el chat: identidad nueva, chat_id nuevo y sin historial.
        //Ya NO recargamos el iframe. Antes esto era un location.reload() disparado por
        //un postMessage de vuelta del loader: si ese mensaje no llegaba, el visitante se
        //quedaba con el hilo borrado y el spinner encendido, sin salida. Y cada recarga
        //volvia a exponer el arranque al fallo de realtime.
        async resetConversacion() {
            //1. El loader rota la identidad: borra ia_infouser y acuña un id nuevo.
            //   postMessage conserva el orden, asi que el get_customer del paso 4 ya
            //   devuelve la identidad nueva.
            this.sendIframe({ 'tipo_peticion': 'reset' });

            //2. Soltamos realtime y token: pertenecen al channel_id viejo.
            await this.cerrar_suscripciones();
            this.supabase_realtime = false;
            this.session_token = false;
            this.session_expires_at = 0;

            //3. Estado de conversacion a cero.
            this.messages = [];
            this.chat = false;
            this.user = false;
            this.init_bot = true;
            this.ended_chat = false;
            this.currentStreamIndex = null;
            this.currentStreamMid = null;
            this.streamArrivedViaRealtime = false;
            this.turnoPintado = false;
            this.turnosLoaderLocal = 0;
            this.statusLabel = '';
            this.convStarted = false;
            this.nativeFormGate = false;
            this.pendingNativeMessage = null;
            //cerrar_chat() habia ocultado la barra de escritura: la devolvemos a su config.
            if (this.hide_bar_write_original !== null) {
                this.widget.hide_bar_write = this.hide_bar_write_original;
                this.hide_bar_write_original = null;
            }

            //4. Recogemos la identidad nueva del loader, con tope: si la pagina anfitriona
            //   no contesta seguimos igualmente con la UI limpia, en vez de colgarnos.
            await Promise.race([
                this.get_data_cliente(),
                new Promise((r) => setTimeout(r, 4000)),
            ]);

            //5. Volvemos a poner el saludo, igual que en el arranque.
            const welcome = this.widget?.layout === 'native' ? '' : this.returnWelcome();
            if (welcome != '') {
                this.messages.push({
                    message: welcome,
                    created_at: new Date().toISOString()
                });
            }

            //6. Si el widget pide formulario previo, el visitante vuelve a identificarse
            //   (la identidad anterior ya no existe). Si no, directo a la ventana de chat.
            this.showChatWindow = this.widget.form != 'true';
            this.loader = false;
        },
        //Enviamos al padre
        sendIframe(msg) {
            window.parent.postMessage(msg, '*');
        },
        //Agregar addevelistener
        bindEvent(element, eventName, eventHandler) {
            if (element.addEventListener) {
                element.addEventListener(eventName, eventHandler, false);
            } else if (element.attachEvent) {
                element.attachEvent('on' + eventName, eventHandler);
            }
        },
        //Actualizamos el widget
        update_visual_widget() {
            this.header.header_type = this.widget.header_type;
            this.header.avatar = this.widget.avatar;
            this.header.header_content_text = this.widget.header_content_text;
            this.header.header_content_img = this.widget.header_content_img;
        },
        //Iniciamos el bot
        /**
         * @param {boolean} cargarMensajes  false = resolver chat y realtime SIN
         *   repintar la conversacion.
         *
         * Se llama desde dos sitios y necesitan cosas distintas:
         *  - Arranque del widget con conversacion previa: SI hay que cargarla.
         *  - Justo despues del PRIMER turno: NO. La respuesta del agente se
         *    persiste de forma ASINCRONA (POST /bot/completeai viaja en
         *    waitUntil), asi que en ese instante la BD todavia no la tiene y
         *    repintar desde `/messages` borraba de pantalla lo que el stream
         *    acababa de escribir; reaparecia segundos despues, cuando el realtime
         *    lo reponia. Como solo ocurre la primera vez (`init_bot`), el fallo
         *    solo se veia en el primer mensaje de la conversacion.
         */
        async iniciar_bot(cargarMensajes = true) {
            this.init_bot = false;
            await this.get_data_user(cargarMensajes);
        },
        //El chat se cerro (por inactividad o desde el panel): mostramos el boton de
        //reinicio y ocultamos la barra de escritura.
        //NO mandamos 'reset' al loader. Antes si lo haciamos, y eso borraba ia_infouser
        //y acuñaba una identidad nueva sin que el visitante hubiera pedido nada: el
        //chat_id se perdia solo con que se cerrase el chat, y con el, el hilo. El reset
        //lo dispara ahora unicamente el boton "Iniciar chat" (resetConversacion).
        async cerrar_chat() {
            this.ended_chat = true;
            // Al cerrarse el chat, apagar el indicador "escribiendo…": si quedó un
            // loader de un turno en vuelo (o el chat cerró por inactividad mientras
            // se esperaba respuesta), sin esto el spinner se queda encendido eterno.
            this.showLoader(false);
            this.statusLabel = "";
            if (this.hide_bar_write_original === null) {
                this.hide_bar_write_original = this.widget.hide_bar_write;
            }
            this.widget.hide_bar_write = 'true';
        },
        //Funcion para regitrar el usuario cuando no existe
        registrar_usuario(data) {
            let data_user = {
                'tipo_peticion': 'save_customer',
                'info_user': data
            };
            this.sendIframe(data_user);
            this.showChatWindow = true;
        },
        //Funcion para validar el email
        validateEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },
        //Dectetamos el envio del formulario
        async sendFormUser() {
            const form = document.querySelector('.send_form_user');
            const inputs = form.querySelectorAll('input');
            let isValid = true;
            inputs.forEach(input => {
                if (input.required || (input.type === 'tel' && this.widget.form_phone_required) || input.type === 'checkbox') {
                    if (input.type === 'checkbox' && !input.checked) {
                        isValid = false;
                    } else if (input.type === 'email' && !this.validateEmail(input.value)) {
                        isValid = false;
                    } else if (input.value.trim() === '') {
                        isValid = false;
                    }
                }
                if (!isValid) {
                    input.classList.add('input_error');
                } else {
                    input.classList.remove('input_error');
                }
            });
            if (isValid) {
                let data = {
                    form_policies: 1
                };
                if (this.form_name !== '') {
                    data.form_name = this.form_name;
                }
                if (this.form_email !== '') {
                    data.form_email = this.form_email;
                }
                if (document.querySelector('input.v-field__input') && document.querySelector('.v-autocomplete__selection span')) {
                    let phone = document.querySelector('input.v-field__input').value;
                    let country = document.querySelector('.v-autocomplete__selection span').innerText;
                    phone = country + '' + phone;
                    phone = phone.replace(/\s/g, '');
                    phone = phone.replace('+', '');
                    data.form_number = phone;
                }
                let btn_send = document.querySelector('.widget_chat_formulario_body_submit button');
                btn_send.disabled = true;
                btn_send.innerHTML = `
                <svg style="margin: auto; background: rgba(255, 255, 255, 0); display: block; shape-rendering: auto;" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <circle cx="50" cy="50" r="32" stroke-width="8" stroke="#ffffff" stroke-dasharray="50.26548245743669 50.26548245743669" fill="none" stroke-linecap="round">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" keyTimes="0;1" values="0 50 50;360 50 50"></animateTransform>
                    </circle>
                </svg> 
                ${this.widget?.translations?.[this.language]?.loading || 'Loading'}...`;
                this.info_user = { ...data, 'id': this.id_user };
                this.registrar_usuario({ ...data, 'id': this.id_user });
                //Native+hero: si veníamos del hero con un mensaje pendiente, lo enviamos ahora
                //(registrar_usuario ya puso showChatWindow=true → cerramos el gate y mandamos).
                if (this.pendingNativeMessage) {
                    const pending = this.pendingNativeMessage;
                    this.pendingNativeMessage = null;
                    this.nativeFormGate = false;
                    this.sendMessage(pending);
                    const ins = helperFunctions.buildMensajeWeb({ text: pending }, this.widget);
                    if (ins) this.messages.push({ message: ins, created_at: new Date().toISOString() });
                }
            }
        },
        toTimestamp(dateStr) {
            if (!dateStr) return 0;
            let s = dateStr;
            if (!/[zZ]|[+-]\d{2}:?\d{2}$/.test(s)) {
                s += 'Z';
            }
            s = s.replace(/(\.\d{3})\d+/, '$1');
            return new Date(s).getTime();
        },
        // Inserta un mensaje del bot manteniendo el orden por created_at SOLO respecto
        // a otros mensajes con id (del servidor, mismo reloj). Recorre desde el final y
        // sube mientras encuentre mensajes de servidor mas nuevos; se detiene en el
        // primer mensaje local (sin id) para no adelantar mensajes del usuario.
        insertBotMessageOrdered(msg) {
            const t = this.toTimestamp(msg.created_at);
            let i = this.messages.length;
            while (i > 0) {
                const prev = this.messages[i - 1];
                if (!prev.id) break;                              // mensaje local (usuario)
                if (this.toTimestamp(prev.created_at) <= t) break; // ya esta ordenado
                i--;
            }
            this.messages.splice(i, 0, msg);
            // Si insertamos antes del placeholder de streaming activo, corrige su indice.
            if (this.currentStreamIndex !== null && i <= this.currentStreamIndex) {
                this.currentStreamIndex++;
            }
        },
        /**
         * Reconciliacion post-turno: el "turno mudo".
         *
         * 🔴 Con `stream_ia` APAGADO en el agente, el backend NO devuelve el bundle
         * de PREPARE: resuelve la IA entera DENTRO de POST /bot/web, persiste el
         * mensaje del agente y solo entonces contesta. La edge cae al fallback y
         * responde `{status:"OK"}` en JSON, o sea: el SSE no trae ni un `text` ni un
         * `turn_started`, y el widget no pinta nada. Quedaba una unica via, el
         * INSERT de realtime, y en el PRIMER turno esa via no existe todavia —la
         * suscripcion se monta en `iniciar_bot()`, que corre DESPUES del POST—, asi
         * que la respuesta ya estaba escrita en `messages` cuando llegaba la
         * suscripcion y no se pintaba nunca: solo aparecia al recargar. Con
         * `stream_ia` encendido no se notaba porque el preview SSE ya la pintaba.
         *
         * Aqui se cierra ese hueco leyendo `/messages` y anadiendo SOLO lo que
         * falta. Es aditivo a proposito (nunca reemplaza `this.messages`): repintar
         * la conversacion entera borraria de pantalla el preview de un turno en
         * vuelo, que es justo el problema documentado en `iniciar_bot`.
         *
         * 🔴 PRIMER TURNO CON `stream_ia` ENCENDIDO (`forzar = true`). El mismo
         * hueco de la suscripcion tardia se traga tambien los mensajes EXTRA del
         * turno —el carrusel de tarjetas y los botones de calificacion, que PHP
         * inserta como filas aparte— pero ahi el turno NO es mudo: el preview SSE
         * ya pinto el texto y `turnoPintado` cortaba la reconciliacion en la
         * primera linea. Resultado: el texto se veia y el carrusel no aparecia
         * hasta recargar (chat 813fbc4c-d631-4dc5-8266-b3d2d29c0107, 2026-09-10:
         * el stream cerro en 13:46:39.641 y las tres filas se escribieron 565 ms
         * despues, cuando la suscripcion aun no estaba montada).
         *
         * Con `forzar` se reconcilia igualmente. No duplica nada: la suscripcion se
         * monta ANTES (dentro de `get_data_messages(false)`), asi que lo que llegue
         * por las dos vias choca contra el dedupe por `id`, y el placeholder del
         * preview se SUSTITUYE en vez de anadirse.
         */
        async reconciliarTurnoMudo(forzar = false, intento = 0) {
            // El turno ya pinto (preview SSE o realtime): no hay nada que reponer.
            // Salvo con `forzar`: el preview solo pinta el texto, y los mensajes
            // extra del mismo turno pueden faltar (ver doc de arriba).
            if (!forzar && this.turnoPintado) return;
            if (!this.chat?.id) return;
            // Placeholder de streaming vivo = el turno SI esta pintando. Reconciliar
            // aqui duplicaria el mensaje (el canonico llega luego por realtime).
            // Con `forzar` el stream YA cerro —se llama en el `finally` del POST—,
            // asi que el placeholder no es un turno en vuelo: es el hueco que hay
            // que sustituir por el mensaje canonico.
            if (!forzar && this.currentStreamIndex !== null) return;

            let data;
            try {
                data = await this.widget_get('/messages', { chat_id: this.chat.id });
            } catch (e) {
                console.error('[reconciliar] no se pudo leer /messages:', e);
                return;
            }
            const messages = data?.messages ?? [];
            let pintado = false;
            let init_slider = false;
            for (const message of messages) {
                // Solo mensajes del bot: los del usuario ya estan pintados en local
                // (sin id), y volver a anadirlos los duplicaria.
                if (message.sender_type === 'user') continue;
                // Dedupe por id contra lo ya pintado (carga inicial o realtime).
                if (!message.id || this.messages.some((m) => m.id === message.id)) continue;
                if (!message?.content?.message) continue;
                const messageInsert = helperFunctions.buildMensajeWeb(
                    message.content.message,
                    this.widget,
                    message
                );
                if (typeof messageInsert === 'string' && messageInsert.includes('swiper-container')) {
                    init_slider = true;
                }
                // Mismo criterio que el handler de realtime: si el placeholder local
                // del stream sigue vivo, el mensaje canonico de ese stream lo
                // SUSTITUYE (mismo texto, pero con id y en su version canonica).
                // Anadirlo dejaria la respuesta pintada dos veces.
                const ph = this.currentStreamIndex !== null ? this.messages[this.currentStreamIndex] : null;
                if (message.content.stream && ph && ph.__local_stream === true) {
                    this.messages.splice(this.currentStreamIndex, 1, {
                        message: messageInsert,
                        created_at: message.created_at,
                        id: message.id,
                        __local_stream: false,
                    });
                    this.currentStreamIndex = null;
                } else {
                    this.insertBotMessageOrdered({
                        message: messageInsert,
                        created_at: message.created_at,
                        id: message.id,
                    });
                }
                pintado = true;
            }
            if (!pintado) {
                // `/widget/messages` lee de una REPLICA. En el camino forzado se
                // consulta a los pocos ms de que PHP escriba las filas (565 ms tras
                // cerrar el stream en el caso medido), asi que la replica puede no
                // tenerlas aun y la reconciliacion se iria de vacio dejando el
                // carrusel perdido para siempre. Reintento acotado; si mientras
                // tanto llegan por realtime, el dedupe por `id` las ignora.
                if (forzar && intento < 3) {
                    await new Promise((r) => setTimeout(r, 800));
                    return this.reconciliarTurnoMudo(true, intento + 1);
                }
                return;
            }
            this.turnoPintado = true;
            // Hay respuesta del agente => el mensaje del usuario esta persistido.
            this.marcarMensajesPersistidos();
            this.scrollBottom();
            if (init_slider) this.initSlider();
            // Si hay OTRO turno en vuelo con burbuja propia (rafaga sin streaming),
            // no la apagamos: la apagara su `apagarLoaderLocal` al cerrar. El 1 es
            // el contador de este mismo turno, que se suelta justo despues.
            if (this.turnosLoaderLocal <= 1) {
                this.showLoader(false);
                this.statusLabel = "";
            }
        },
        //Escuchamos los mensajes
        async listen_messages() {
            // Idempotente: si ya hay suscripcion previa, removerla antes de crear otra.
            // Sin esto, Supabase cicla CLOSED/SUBSCRIBED y se pierden eventos en el medio.
            if (this.subscription_message) {
                try {
                    await this.supabase_realtime.removeChannel(this.subscription_message);
                } catch (e) {
                    console.error('[RT][messages] error al remover canal previo', e);
                }
                this.subscription_message = false;
            }
            const subscription_message = this.supabase_realtime
                .channel('messages_realtime_channel')
                .on(
                    'postgres_changes',
                    {
                        event: 'INSERT',
                        schema: 'public',
                        table: 'messages',
                        filter: `chat_id=eq.${this.chat.id}`
                    },
                    async (payload) => {
                        if (!payload?.new?.content?.message) return;

                        // Ignora los mensajes del usuario (esos tú ya los pintas localmente),
                        // pero ANTES aprovecha la señal: que exista la fila significa que lo
                        // que el cliente escribio ya esta persistido -> segundo check.
                        if (payload.new.sender_type === "user") {
                            this.marcarMensajesPersistidos();
                            return;
                        }
                        // Si llega la respuesta del agente, los mensajes del usuario de ese
                        // turno estan persistidos por definicion. Cubre el caso en que el
                        // INSERT del usuario se perdiera (suscripcion montada tarde).
                        this.marcarMensajesPersistidos();

                        // Dedupe por id: un mismo INSERT puede llegar dos veces (re-suscripcion,
                        // reconexion). Si ya lo pintamos, lo ignoramos para no duplicar.
                        const newId = payload.new.id;
                        if (newId && this.messages.some((m) => m.id === newId)) return;

                        // P0-3: firmar adjuntos entrantes antes de renderizar (bucket privado).
                        await this.signMessageAttachments(payload.new.content);

                        const messageInsert = helperFunctions.buildMensajeWeb(
                            payload.new.content.message,
                            this.widget,
                            payload.new
                        );
                        const isSupabaseStream = !!payload.new.content.stream;
                        // Solo reemplazamos el placeholder de streaming si ese slot SIGUE siendo
                        // el placeholder local (__local_stream === true). Si ya fue finalizado por
                        // un INSERT anterior, currentStreamIndex puede haber quedado obsoleto: sin
                        // este guard, el splice sobreescribia un mensaje ya pintado y lo hacia
                        // "desaparecer". En ese caso caemos al insertado ordenado.
                        // Marcamos que realtime ya entrego el mensaje del turno: el preview
                        // SSE deja de renderizar (evita el duplicado en cualquier orden de
                        // llegada). Solo aplica a mensajes de stream (los que tambien pasan
                        // por SSE); los no-stream no compiten con el preview.
                        if (isSupabaseStream) {
                            this.streamArrivedViaRealtime = true;
                        }
                        const ph = this.currentStreamIndex !== null ? this.messages[this.currentStreamIndex] : null;
                        if (isSupabaseStream && ph && ph.__local_stream === true) {
                            this.messages.splice(this.currentStreamIndex, 1, {
                                message: messageInsert,
                                created_at: payload.new.created_at,
                                id: newId,
                                __local_stream: false,
                            });
                            this.currentStreamIndex = null;
                        } else {
                            // Mensaje adicional del mismo turno (el bot puede emitir varios) o sin
                            // placeholder activo. Los eventos casi simultaneos llegan a veces fuera
                            // de orden, asi que insertamos por created_at PERO solo respecto a otros
                            // mensajes del servidor (con id, mismo reloj). Nunca pasamos por delante
                            // de un mensaje local del usuario (sin id, reloj del navegador), para no
                            // reintroducir el salto por desfase de relojes.
                            this.insertBotMessageOrdered({
                                message: messageInsert,
                                created_at: payload.new.created_at,
                                id: newId,
                            });
                        }
                        // Realtime ya pinto algo del bot en este turno: la
                        // reconciliacion post-turno (turno mudo) no hace falta.
                        this.turnoPintado = true;
                        this.scrollBottom();
                        this.initSlider();
                        // Misma guarda que en reconciliarTurnoMudo: con una rafaga
                        // sin streaming puede quedar otro turno en vuelo.
                        if (this.turnosLoaderLocal <= 1) {
                            this.showLoader(false);
                        }
                        if (payload.new?.sender_type !== "system") {
                            this.sendIframe({
                                tipo_peticion: "new_message",
                                message: payload.new.content.message,
                            });
                        }
                    }
                )
                .subscribe((status, err) => {
                    if (status !== 'SUBSCRIBED') {
                        console.warn('[RT][messages] status=', status, err ? ('err=' + (err.message || err)) : '');
                    }
                });
            this.subscription_message = subscription_message;
        },
        //Escuchamos los cambios en el chat
        async listen_chat() {
            // Idempotente: si ya hay suscripcion previa, removerla antes de crear otra.
            if (this.subscription_chat) {
                try {
                    await this.supabase_realtime.removeChannel(this.subscription_chat);
                } catch (e) {
                    console.error('[RT][chat] error al remover canal previo', e);
                }
                this.subscription_chat = false;
            }
            const subscription = this.supabase_realtime
                .channel('chat_realtime_channel')
                .on(
                    'postgres_changes',
                    {
                        event: 'UPDATE',
                        schema: 'public',
                        table: 'chats',
                        filter: `id=eq.${this.chat.id}`
                    },
                    (payload) => {
                        this.chat = payload.new;
                        // Si el chat paso a agente humano (queue/human), apagamos el loader
                        // por si quedo encendido de un mensaje anterior en modo aiagent.
                        if (this.chat.status === 'queue' || this.chat.status === 'human') {
                            this.showLoader(false);
                        }
                        //Cerramos el chat si ya esta cerrado
                        if (this.chat.ended_at !== null) {
                            this.cerrar_chat();
                        }
                    }
                )
                .subscribe((status, err) => {
                    if (status !== 'SUBSCRIBED') {
                        console.warn('[RT][chat] status=', status, err ? ('err=' + (err.message || err)) : '');
                    }
                });
            this.subscription_chat = subscription;
        },
        //Mostramos u ocultamos el loader
        showLoader(show) {
            this.loader = show;
        },
        /**
         * Enciende la burbuja de "escribiendo" en los turnos que NO streamean.
         *
         * 🔴 Con `stream_ia` apagado, el backend resuelve la IA entera dentro del
         * POST y la edge `/web/stream` contesta un JSON, no un SSE: no hay
         * `turn_started`, que es quien enciende la burbuja en el camino normal
         * (ver sendPostRequest). Sin esto el visitante ve la pantalla quieta durante
         * todo el turno y la respuesta aparece de golpe.
         *
         * Encenderla aqui NO reintroduce el parpadeo que motivo quitarla del envio
         * (ver sendMessage): aquel lo causaba el POST que perdia el lease al apagar
         * la burbuja al cerrar su stream, y en este camino nadie la apaga salvo el
         * contador de abajo.
         *
         * @returns {boolean} true si ESTE turno la encendio, o sea si le toca
         *   apagarla al cerrar.
         */
        encenderLoaderLocal() {
            if (!this.streamIaDesactivado) return false;
            if (this.ended_chat) return false;
            // Misma guarda que `turn_started`: en manos de un humano no hay IA
            // escribiendo.
            if (this.chat?.status === 'queue' || this.chat?.status === 'human') return false;
            this.turnosLoaderLocal++;
            this.showLoader(true);
            this.scrollBottom();
            return true;
        },
        /**
         * Contrapartida de encenderLoaderLocal. Solo apaga cuando ya no queda
         * ningun turno en vuelo: en una rafaga, el POST que cierra en vacio (lote
         * agrupado o lease ocupado) no debe apagar la burbuja del turno que si
         * esta corriendo.
         */
        apagarLoaderLocal(encendido) {
            if (!encendido) return;
            this.turnosLoaderLocal = Math.max(0, this.turnosLoaderLocal - 1);
            if (this.turnosLoaderLocal === 0) {
                this.showLoader(false);
                this.statusLabel = "";
            }
        },
        /**
         * Pasa a DOBLE CHECK todos los mensajes del usuario que seguian con uno solo.
         *
         * Se marcan todos y no solo el confirmado a proposito: los mensajes se
         * persisten en orden y, con el turno agrupado, en LOTE — si hay fila para
         * uno, los anteriores de la rafaga ya estan escritos. Evita tener que
         * emparejar por `mid`, que el eco local no conserva.
         *
         * Si un turno falla antes de persistir, sus mensajes se quedan con un check:
         * es exacto, no hay fila en `messages`.
         */
        marcarMensajesPersistidos() {
            let tocados = 0;
            this.messages = this.messages.map((m) => {
                if (typeof m.message !== 'string' || !m.message.includes('data-ack="1"')) {
                    return m;
                }
                tocados++;
                return {
                    ...m,
                    message: m.message.replace(
                        /(<span class="lv-ack" )data-ack="1"([^>]*>)&#10003;(<\/span>)/g,
                        '$1data-ack="2"$2&#10003;&#10003;$3',
                    ),
                };
            });
            if (tocados > 0) {
                console.log(`[ack] ${tocados} mensaje(s) del usuario -> doble check`);
            }
        },
        // Texto localizado para el evento `status` del stream (agente usando una
        // tool). Si el evento trae `detail` (la consulta que busca, la web que abre,
        // cuántos documentos verifica) se monta un texto con ese dato real; si no,
        // el genérico de la tool. Sin traducción cae al `label` que mandó el backend
        // (ES) y, en último caso, a un genérico. No depende de la config del widget.
        toolStatusLabel(payload) {
            const lang = (this.language || 'es').split('-')[0];
            const MAP = {
                es: {
                    lovi_search: '📚 Consultando la base de conocimiento…',
                    lovi_products_search: '🛍️ Buscando productos…',
                    brave_web_search: '🌐 Buscando en la web…',
                    openai_web_search: '🌐 Buscando en la web…',
                    speakap_search: '📣 Buscando en tu red…',
                    document_verify: '📄 Verificando documentos…',
                    _default: '🔍 Consultando información…',
                    search_kb: '📚 Buscando «{q}» en la base de conocimiento…',
                    search_network: '📣 Buscando «{q}» en tu red…',
                    search: '🔍 Buscando «{q}»…',
                    search_web: '🌐 Buscando «{q}»…',
                    open_page: '🌐 Leyendo {site}…',
                    open_document: '📄 Abriendo un documento de {site}…',
                    verify_one: '📄 Verificando el documento…',
                    verify_many: '📄 Verificando {n} documentos…',
                },
                en: {
                    lovi_search: '📚 Searching the knowledge base…',
                    lovi_products_search: '🛍️ Looking up products…',
                    brave_web_search: '🌐 Searching the web…',
                    openai_web_search: '🌐 Searching the web…',
                    speakap_search: '📣 Searching your network…',
                    document_verify: '📄 Checking documents…',
                    _default: '🔍 Looking that up…',
                    search_kb: '📚 Searching the knowledge base for “{q}”…',
                    search_network: '📣 Searching your network for “{q}”…',
                    search: '🔍 Searching for “{q}”…',
                    search_web: '🌐 Searching for “{q}”…',
                    open_page: '🌐 Reading {site}…',
                    open_document: '📄 Opening a document from {site}…',
                    verify_one: '📄 Checking the document…',
                    verify_many: '📄 Checking {n} documents…',
                },
                pt: {
                    lovi_search: '📚 Consultando a base de conhecimento…',
                    lovi_products_search: '🛍️ Procurando produtos…',
                    brave_web_search: '🌐 Pesquisando na web…',
                    openai_web_search: '🌐 Pesquisando na web…',
                    speakap_search: '📣 Pesquisando na sua rede…',
                    document_verify: '📄 Verificando documentos…',
                    _default: '🔍 Consultando informações…',
                    search_kb: '📚 Procurando «{q}» na base de conhecimento…',
                    search_network: '📣 Procurando «{q}» na sua rede…',
                    search: '🔍 Procurando «{q}»…',
                    search_web: '🌐 Pesquisando «{q}»…',
                    open_page: '🌐 Lendo {site}…',
                    open_document: '📄 Abrindo um documento de {site}…',
                    verify_one: '📄 Verificando o documento…',
                    verify_many: '📄 Verificando {n} documentos…',
                },
                fr: {
                    lovi_search: '📚 Consultation de la base de connaissances…',
                    lovi_products_search: '🛍️ Recherche de produits…',
                    brave_web_search: '🌐 Recherche sur le web…',
                    openai_web_search: '🌐 Recherche sur le web…',
                    speakap_search: '📣 Recherche dans votre réseau…',
                    document_verify: '📄 Vérification des documents…',
                    _default: '🔍 Recherche en cours…',
                    search_kb: '📚 Recherche de « {q} » dans la base de connaissances…',
                    search_network: '📣 Recherche de « {q} » dans votre réseau…',
                    search: '🔍 Recherche de « {q} »…',
                    search_web: '🌐 Recherche de « {q} »…',
                    open_page: '🌐 Lecture de {site}…',
                    open_document: '📄 Ouverture d’un document de {site}…',
                    verify_one: '📄 Vérification du document…',
                    verify_many: '📄 Vérification de {n} documents…',
                },
            };
            const table = MAP[lang] || MAP.es;
            const tool = payload?.tool;
            const d = payload?.detail || {};
            const fill = (tpl, vars) => tpl.replace(/\{(\w+)\}/g, (_, k) => vars[k] ?? '');
            if (d.action === 'search' && d.query) {
                const key = tool === 'lovi_search' ? 'search_kb'
                    : tool === 'speakap_search' ? 'search_network'
                    : (tool === 'brave_web_search' || tool === 'openai_web_search') ? 'search_web'
                    : 'search';
                return fill(table[key], { q: d.query });
            }
            if (d.action === 'open_page' && d.site) {
                return fill(table[d.document ? 'open_document' : 'open_page'], { site: d.site });
            }
            if (d.action === 'verify' && d.count > 0) {
                return d.count === 1 ? table.verify_one : fill(table.verify_many, { n: d.count });
            }
            return table[tool] || table._default || payload?.label || '…';
        },
        //Enviar a supabase a ver si ya cancelo el chat.
        //Usa /widget/status_chat (autenticado con la tupla access_key+id_widget+channel_id
        //via widget_get) en vez del legacy /web/status_chat, que era público y confiaba
        //en el chat_id como si fuera autorización.
        async verifyChatSupabase(chatId) {
            try {
                const data = await this.widget_get('/status_chat', { chat_id: chatId });
                //null = error HTTP/red (widget_get ya lo logueó): no cerramos el chat,
                //solo detenemos la inicialización, igual que el catch de antes.
                if (data === null) return;
                if (data?.status === false) {
                    console.log('cierre verifyChatSupabase')
                    this.cerrar_chat();
                    return false;
                }
                return true;
            } catch (error) {
                console.error('Error en la petición:', error);
            }
        },
        //Enviamos por post el mensaje
        async sendPostRequest(json_payload) {
            // Nuevo turno: limpiamos el estado de streaming. currentStreamIndex de un
            // turno anterior no debe arrastrarse, y el preview SSE vuelve a renderizar.
            this.currentStreamIndex = null;
            this.streamArrivedViaRealtime = false;
            this.turnoPintado = false;
            this.statusLabel = "";
            // Ver comentario en sendMessage: la burbuja la enciende `turn_started`.
            const res = await fetch(
                `${process.env.VUE_APP_SUPABASE_URL}functions/v1/web/stream`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "text/event-stream",
                    },
                    body: JSON.stringify({
                        object: "web_business_account",
                        company: this.company,
                        name_company: this.name_company,
                        json_payload: json_payload
                    })
                },
            );

            if (!res.ok || !res.body) {
                console.error(await res.text());
                // No se apaga: esta peticion nunca encendio la burbuja, y si hay
                // otro turno en vuelo la suya debe seguir.
                return;
            }

            let textIndex = null;
            let lastDelta = "";
            let fullText = "";
            const reader = res.body.getReader();
            const decoder = new TextDecoder();
            let buffer = "";
            let done = false;
            let is_event = false;
            // Solo este stream puede apagar lo que este stream encendio. Sin la
            // bandera, un stream que cierra en vacio apagaria la burbuja del turno
            // que si esta corriendo en otra peticion.
            let turnoArrancado = false;

            while (!done) {
                const { value, done: end } = await reader.read();
                done = end;
                if (done) break;

                const chunk = decoder.decode(value, { stream: true });
                buffer += chunk;
                const parts = buffer.split("\n\n");
                buffer = parts.pop() ?? "";

                for (const part of parts) {
                    if (!part.startsWith("data:")) continue;
                    const jsonStr = part.slice(5).trim();
                    if (jsonStr === "[DONE]") continue;

                    let payload;
                    try { payload = JSON.parse(jsonStr); } catch { continue; }

                    if (payload.type == "event_activated") {
                        is_event = true;
                    }
                    // 🔴 RESPUESTA SIN CHUNKS. Hay turnos que no streamean nada y
                    // mandan la respuesta entera en un unico `final_answer`: el
                    // fast-path del saludo de bienvenida (`welcome_fastpath: true`,
                    // 0 tokens, no llama al modelo) es el caso habitual, y por eso
                    // esto solo se notaba en el PRIMER mensaje de la conversacion.
                    //
                    // El bucle de abajo solo pinta con `type === "text"`, asi que sin
                    // esta conversion no se pintaba nada y la respuesta aparecia
                    // varios segundos despues, cuando el realtime la reponia.
                    //
                    // Se convierte en un `text` no incremental y sigue el camino
                    // normal. La guarda `textIndex === null` lo limita al caso real:
                    // si el turno SI mando chunks, ya hay texto pintado y el
                    // `final_answer` se ignora como hasta ahora.
                    if (
                        payload.type === "final_answer" && !is_event && textIndex === null &&
                        typeof payload.answer === "string" && payload.answer.trim() !== ""
                    ) {
                        payload = { type: "text", delta: false, content: payload.answer };
                    }
                    // El servidor confirma que hay turno de IA en marcha: ventana
                    // cerrada, lease ganado y pydantic respondiendo. Es el unico
                    // momento en que tiene sentido mostrar "escribiendo...".
                    if (payload.type === "turn_started") {
                        // El turno arranca DESPUES de que /bot/web haya persistido el
                        // lote, asi que este evento ya implica "esta en `messages`":
                        // doble check. Hace falta ademas del realtime porque en el
                        // PRIMER mensaje la suscripcion se monta en iniciar_bot, o sea
                        // despues del turno, y el INSERT del usuario se pierde.
                        this.marcarMensajesPersistidos();
                        if (this.chat?.status !== 'queue' && this.chat?.status !== 'human') {
                            turnoArrancado = true;
                            this.showLoader(true);
                            // Sin esto la burbuja se pinta FUERA de la vista cuando la
                            // conversacion ya tiene scroll: esta encendida pero no se
                            // ve, y el efecto es el mismo que no mostrarla.
                            this.scrollBottom();
                        }
                        continue;
                    }
                    // Estado intermedio: el agente está usando una tool (lovi_search,
                    // etc.). Mostramos la leyenda contextual en el loader mientras
                    // corre. No reactivamos el indicador si ya llegó texto o si el
                    // realtime ya pintó el mensaje final.
                    if (payload.type === "status" && !is_event) {
                        if (this.streamArrivedViaRealtime || textIndex !== null) continue;
                        this.statusLabel = this.toolStatusLabel(payload);
                        this.showLoader(true);
                        continue;
                    }
                    if (payload.type === "text" && !is_event) {
                        this.showLoader(false);
                        this.statusLabel = "";
                        // Si el INSERT de realtime ya pinto el mensaje final (gano la
                        // carrera, o llego mientras seguia el stream), dejamos de renderizar
                        // el preview: el realtime es la version canonica (trae quick_replies,
                        // ui_components, etc.). Esto evita el mensaje duplicado.
                        if (this.streamArrivedViaRealtime) continue;
                        if (payload.delta && payload.content === lastDelta) continue;
                        if (payload.delta) {
                            fullText += payload.content;
                            lastDelta = payload.content;
                        } else {
                            fullText = payload.content;
                            lastDelta = "";
                        }
                        if (textIndex === null) {
                            const nowIso = new Date().toISOString();
                            this.messages.push({
                                message: '<div class="widget_message widget_message_bot"><div class="widget_message_content"></div></div>',
                                created_at: nowIso,
                                __local_stream: true,
                            });
                            textIndex = this.messages.length - 1;
                            this.currentStreamIndex = textIndex;
                        }
                        this.turnoPintado = true;
                        // Actualiza el contenido que se va llenando.
                        // Pasa por el MISMO render que el mensaje canonico
                        // (`buildMensajeWeb`): sin esto el preview pintaba el
                        // Markdown crudo y se veian los `**` de las negritas
                        // durante todo el turno — y para siempre si el INSERT
                        // de realtime no llegaba a reponer el mensaje. Con un
                        // delta a medias (`**deix`) markdown-it deja los
                        // asteriscos literales y se resuelve en el siguiente.
                        const rendered = helperFunctions.renderRichText(fullText);
                        this.messages[textIndex].message =
                            this.messages[textIndex].message.replace(
                                /<div class="widget_message_content[^"]*">[\s\S]*?<\/div>/,
                                // Replacer como funcion: con un string, un `$&`
                                // o `$'` dentro del texto del modelo se
                                // interpretaria como patron de sustitucion.
                                () => `<div class="widget_message_content ${rendered.is_markdown ? 'widget_message_content_markdown' : ''}">${rendered.html}</div>`
                            );
                        this.scrollBottom();
                        continue;
                    }
                    if (payload.type === "complete") {
                        if (!is_event) {
                            const ui = payload?.metadata?.ui_components;
                            if (ui?.length > 0 && textIndex !== null && this.messages[textIndex]) {
                                const html = helperFunctions.buildUiComponentsHtml(ui, this.widget);
                                if (html) {
                                    this.messages[textIndex].message += html;
                                    this.scrollBottom();
                                    this.initSlider();
                                }
                            }
                        }
                        continue;
                    }
                }
            }
            // Fin del stream: apagar el loader aunque el turno no haya producido
            // texto (chat cerrado por inactividad, solo evento `status`, o stream
            // vacío). Sin esto el indicador "escribiendo…" quedaba encendido
            // eternamente tras cerrarse el chat.
            // PERO solo si fue ESTE stream quien lo encendio: un cierre en vacio
            // —POST que perdio el lease o la ventana— no debe apagar la burbuja
            // del turno que si esta corriendo.
            if (turnoArrancado) {
                this.showLoader(false);
                this.statusLabel = "";
            }
        },
        //Enviamos el mensaje
        async sendMessage(message, idmessage = false, isMedio = false, is_button = false) {
            //Salimos del landing hero (modo nativo) al primer envío
            this.convStarted = true;
            // 🔴 La burbuja de "escribiendo" YA NO se enciende al pulsar enter.
            // La enciende el evento `turn_started` que manda el servidor cuando el
            // turno arranca de verdad. Motivo: en una rafaga, cada envio la
            // encendia y el POST que perdia el lease (o la ventana de debounce) la
            // apagaba al cerrar su stream — parpadeaba y parecia que no pasaba nada
            // hasta que llegaba la respuesta.
            this.scrollBottom();
            //Ocultamos las opciones
            this.showToolsContent = false;
            //Constructuimos el mensaje para enviar
            let json_payload = {
                "sender": {
                    "id": this.id_user,
                    "lang": this.language,
                    "info_user": this.info_user
                },
                "agent": {
                    "id": this.agent_id_to_chat(),
                },
                "context_extra": this.contexto_extra,
                "timestamp": new Date().toISOString(),
                "metadata": false
            };
            //Verificamos si hay data collection para enviar
            if (this.widget?.data_collection && this.widget.data_collection) {
                await this.get_data_collection();
                const metadata = {};
                const infoExtras = {};
                if (typeof this.data_collection.url === 'string') {
                    metadata.url = this.data_collection.url;
                }
                Object.entries(this.data_collection).forEach(([key, item]) => {
                    if (key === 'url') return;
                    if (!item || typeof item !== 'object') return;
                    const { value, type } = item;
                    if (type === 'metadata') {
                        metadata[key] = value;
                    } else if (type === 'info_user') {
                        infoExtras[key] = value;
                    }
                });
                json_payload.metadata = metadata;
                json_payload.sender.info_user = {
                    ...json_payload.sender.info_user,
                    ...infoExtras
                };
            }
            //Verificamos que no sea medio
            if (isMedio) {
                json_payload.message = message;
                json_payload.message.mid = "web_" + Date.now() + "_" + Math.random().toString(36).substring(2, 10);
            } else if (is_button) {
                json_payload.message = is_button;
                json_payload.message.text = message;
                json_payload.message.mid = "web_" + Date.now() + "_" + Math.random().toString(36).substring(2, 10);
            } else {
                json_payload.message = {
                    "mid": "web_" + Date.now() + "_" + Math.random().toString(36).substring(2, 10),
                    "text": message
                };
            }
            //Si es que existe el id del mensaje lo agregamos al reply_to
            if (idmessage) {
                json_payload.message.reply_to = {
                    "mid": idmessage
                };
            }
            //Enviamos el mensaje por post.
            //Con `stream_ia` apagado no llega `turn_started`: la burbuja de
            //"escribiendo" la enciende el widget (ver encenderLoaderLocal).
            const loaderLocal = this.encenderLoaderLocal();
            try {
                await this.sendPostRequest(json_payload);
            } finally {
                //Cierre del turno. Va sin await a proposito (no debe bloquear el
                //envio), pero SI con catch: sin el, cualquier fallo aqui era una
                //promesa rechazada que no se veia. En `finally` para que un POST
                //que revienta no deje la burbuja encendida para siempre.
                const cierreTurno = this.init_bot
                    // Sin repintar: la conversacion ya esta en pantalla y la
                    // respuesta del turno aun no esta persistida (ver iniciar_bot).
                    // La reconciliacion va DESPUES: `iniciar_bot` es quien monta la
                    // suscripcion de realtime, y sin ella el turno mudo del primer
                    // mensaje no tendria quien lo repusiera.
                    // Forzada (`true`): en el primer turno la suscripcion llega tarde
                    // tambien CON stream, y los mensajes extra —carrusel, botones de
                    // calificacion— se perdian aunque el preview hubiera pintado el
                    // texto. Ver la doc de `reconciliarTurnoMudo`.
                    ? this.iniciar_bot(false).then(() => this.reconciliarTurnoMudo(true))
                    // Turno mudo (`stream_ia` apagado, o SSE que cerro en vacio): si
                    // no se pinto nada, la respuesta ya esta en BD y se repone desde
                    // `/messages` sin tocar lo que hay en pantalla.
                    : this.reconciliarTurnoMudo();
                cierreTurno
                    .catch((e) => {
                        console.error('[Error] cierre del turno tras enviar mensaje:', e);
                    })
                    .finally(() => {
                        this.apagarLoaderLocal(loaderLocal);
                    });
            }
            //Verificamos si es medio para apagar el clip de loading
            if (isMedio) {
                this.loadingClip = true;
            }
        },
        //envio de imagenes
        async sendFormMessageMedio() {
            //Guarda: si la configuración no permite adjuntos, ignoramos el evento
            if (!this.allowAttachFile) return;
            try {
                this.loadingClip = false;
                await this.ensure_session_token();
                const supabase = this.supabase_realtime;
                if (!supabase) {
                    console.error('No hay cliente supabase para upload');
                    this.loadingClip = true;
                    return;
                }
                // Obtenemos el archivo seleccionado
                const medio = document.getElementById('messageMedia');
                if (!medio || medio.files.length === 0) {
                    this.loadingClip = false;
                    return;
                }
                const file = medio.files[0];
                // Validar el tipo de archivo
                const fileType = file.type; // Formato MIME del archivo
                let typeCategory;
                if (fileType.startsWith("image/")) {
                    typeCategory = "image";
                } else if (fileType.startsWith("video/")) {
                    typeCategory = "video";
                } else if (fileType.startsWith("audio/")) {
                    typeCategory = "audio";
                } else if (
                    fileType.startsWith("application/") ||
                    fileType === "text/plain"
                ) {
                    typeCategory = "document";
                } else {
                    console.error("Tipo de archivo no permitido:", fileType);
                    return;
                }
                // Generar un nombre único basado en timestamp y un sufijo aleatorio
                const timestamp = Date.now(); // Timestamp en milisegundos
                const randomString = Math.random().toString(36).substring(2, 8); // Generar una cadena aleatoria de 6 caracteres
                const fileExtension = file.name.split('.').pop(); // Obtener la extensión del archivo
                const uniqueFileName = `${timestamp}-${randomString}.${fileExtension}`; // Nombre único del archivo
                // Configuración del bucket y del cliente Supabase
                const bucketName = "chat-media"; // P0-3: bucket privado de adjuntos de chat
                // P0-3 Etapa 2: ruta por prefijo de tenant {company_id}/{chat_id}/…
                // La RLS de storage exige que el 1er segmento sea el company_id del
                // JWT de sesión. company_id viene de /widget/user (this.user).
                const companyId = this.user?.company_id;
                if (!companyId) {
                    console.error('[widget] falta company_id para subir el adjunto');
                    return;
                }
                const chatSeg = this.chat?.id || 'pending';
                const filePath = `${companyId}/${chatSeg}/${uniqueFileName}`;
                // Carga el archivo al bucket de Supabase
                const { error } = await supabase.storage
                    .from(bucketName)
                    .upload(filePath, file, {
                        cacheControl: "3600",
                        upsert: false, // Evitar sobrescribir archivos existentes
                    });
                if (error) {
                    console.error("Error al cargar el archivo:", error.message);
                    return;
                }
                // Obtener la URL pública del archivo (se persiste junto a storage_path;
                // en lectura la firma la edge /widget/messages).
                const { data: publicUrlData } = supabase.storage.from(bucketName).getPublicUrl(filePath);
                const publicUrl = publicUrlData.publicUrl;
                // P0-3: para el render LOCAL optimista, con el bucket privado la URL
                // pública no carga (imagen rota). Firmar aquí con el cliente de sesión.
                let displayUrl = publicUrl;
                try {
                    const { data: signed } = await supabase.storage.from(bucketName).createSignedUrl(filePath, 3600);
                    if (signed?.signedUrl) displayUrl = signed.signedUrl;
                } catch (e) {
                    console.warn('[widget] createSignedUrl falló, uso url pública', e);
                }
                // Lo que se envía al backend lleva la url pública + storage_path.
                let send_message_media = {
                    attachments: [
                        {
                            "type": typeCategory,
                            "url": publicUrl,
                            // P0-3: ruta del objeto para firmar en lectura (bucket privado).
                            "storage_path": filePath
                        }
                    ]
                };
                // Enviamos el mensaje multimedia
                this.sendMessage(send_message_media, false, true);
                // Render local con la URL FIRMADA (no la pública).
                let render_media = {
                    attachments: [{ "type": typeCategory, "url": displayUrl, "storage_path": filePath }]
                };
                let messageInsert = helperFunctions.buildMensajeWeb(render_media, this.widget);
                if (messageInsert != "") {
                    this.messages.push({
                        message: messageInsert,
                        created_at: new Date().toISOString(),
                    });
                }
            } catch (error) {
                console.error("Error general:", error);
                alert("Ocurrió un error inesperado");
            }
        },
        //Funcion para enviar el mensaje
        sendFormMessage() {
            const raw = document.getElementById('inputMessage').value;
            const message = DOMPurify.sanitize(raw, {
                ALLOWED_TAGS: [],
                ALLOWED_ATTR: []
            }).trim();
            if (message === '') return;
            //Native+hero con form: abrimos el formulario como paso previo y guardamos el mensaje
            if (this.maybeGateNativeForm(message)) { document.getElementById('inputMessage').value = ''; return; }
            if (!this.policyOk()) return;
            document.getElementById('inputMessage').value = '';

            this.sendMessage(message);
            const messageInsert = helperFunctions.buildMensajeWeb({ text: message }, this.widget);
            if (messageInsert) {
                this.messages.push({
                    message: messageInsert,
                    created_at: new Date().toISOString()
                });
            }
            if (this.widget.fullwidth === true || this.is_mobile) {
                this.$refs.textarea.blur();
            }
            document.getElementById('inputMessage').style.height = this.medidasTextarea + 'px';
            this.resizeTextarea();
        },
        //Gate de políticas (modo nativo): exige el check si el widget tiene form_policy
        //y NO hay formulario (si hay form, la política se acepta dentro del formulario).
        policyOk() {
            if (this.widget?.layout === 'native' && this.widget?.form_policy && this.widget?.form != 'true'
                && !this.convStarted && !this.policyAccepted) {
                this.policyError = true;
                return false;
            }
            return true;
        },
        //Gate del formulario (native+hero con form:true): al primer envío desde el hero,
        //mostramos el formulario y guardamos el mensaje como pendiente. Devuelve true si frenó.
        maybeGateNativeForm(message) {
            if (this.isNativeHero && this.widget.form == 'true' && !this.showChatWindow) {
                this.pendingNativeMessage = message;
                this.nativeFormGate = true;
                return true;
            }
            return false;
        },
        //Enviar un topic del hero (modo nativo) como si el usuario lo hubiera escrito
        sendTopic(text) {
            if (!text) return;
            if (this.maybeGateNativeForm(text)) return;
            if (!this.policyOk()) return;
            this.sendMessage(text);
            const messageInsert = helperFunctions.buildMensajeWeb({ text }, this.widget);
            if (messageInsert) {
                this.messages.push({
                    message: messageInsert,
                    created_at: new Date().toISOString()
                });
            }
        },
        //Funcion para detectar los clisk de los botones
        handleDynamicItemClick(event) {
            const target = event.target;
            const data_parent = this;
            if (target.classList.contains('widget_card_boton') || target.classList.contains('widget_message_boton')) {
                let text = target.innerText;
                let payload = target.getAttribute('payload');
                let type = target.getAttribute('type');
                let idmessage = target.getAttribute('idmessage');
                if (type == 'web_url') {
                    window.open(payload, '_blank');
                } else {
                    data_parent.sendMessage(text, idmessage, false,
                        {
                            'quick_reply': {
                                'payload': payload
                            }
                        });
                    let messageInsert = helperFunctions.buildMensajeWeb({ text: text }, this.widget);
                    if (messageInsert != "") {
                        this.messages.push({
                            message: messageInsert,
                            created_at: new Date().toISOString()
                        });
                    }
                }
            }
        },
        //Bajamos el scroll a bottom
        scrollBottom() {
            setTimeout(() => {
                const chatBody = document.getElementById('chatBody');
                chatBody.scrollTo({
                    top: chatBody.scrollHeight,
                    behavior: 'smooth'
                });
            }, 500);
        },
        resizeTextarea() {
            const textarea = this.$refs.textarea;
            textarea.style.height = '0';
            textarea.style.height = textarea.scrollHeight + 3 + 'px';
            let alturaTextarea = textarea.scrollHeight;
            if (alturaTextarea > 100) {
                alturaTextarea = 100 - this.medidasTextarea;
            } else {
                alturaTextarea = alturaTextarea - this.medidasTextarea;
            }
            let chatBody = document.getElementById('chatBody');
            chatBody.style.height = (this.alturaChatbody - alturaTextarea) + 'px';
        },
        //Cargar slider
        initSlider() {
            setTimeout(() => {
                new window.Swiper('.swiper', {
                    slidesPerView: "auto",
                    spaceBetween: 20,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }
                });
            }, 500);
        },
        //Funcion para el scroll
        handleScroll() {
            const chatBody = document.getElementById('chatBody');
            const scrollTop = chatBody.scrollTop;
            const scrollHeight = chatBody.scrollHeight;
            const offsetHeight = chatBody.offsetHeight;
            if (scrollTop + offsetHeight >= scrollHeight) {
                document.querySelector('.action_to_bottom').classList.remove('active');
            } else {
                document.querySelector('.action_to_bottom').classList.add('active');
            }
        },
        //Fucnones de doom
        tools_window_wiget() {
            let interval = setInterval(() => {
                let chatBody = document.getElementById('chatBody');
                if (chatBody != null) {
                    clearInterval(interval);
                    let chatBody = document.getElementById('chatBody');
                    let alturaChatBody = chatBody.offsetHeight;
                    this.alturaChatbody = alturaChatBody;
                }
            }, 500);
            //Deshabilitamos el zoom
            //Bloquear gestos de zoom
            document.addEventListener('gesturestart', function (e) {
                e.preventDefault();
            });
            document.addEventListener('gesturechange', function (e) {
                e.preventDefault();
            });
            document.addEventListener('gestureend', function (e) {
                e.preventDefault();
            });
            // Desactivar el zoom por doble toque
            let lastTouchEnd = 0;
            document.addEventListener('touchend', function (event) {
                const now = (new Date()).getTime();
                if (now - lastTouchEnd <= 300) {
                    event.preventDefault();
                }
                lastTouchEnd = now;
            }, false);
        },
        //Retornar el id del agente
        agent_id_to_chat() {
            if (this.chat?.agent_id) {
                return this.chat.agent_id;
            }
            if (this?.info_user?.agent_id) {
                return this.info_user.agent_id;
            }
            return this.agent;
        },
        //Retornamos el welcome
        returnWelcome() {
            let welcome = '';
            if (this.widget?.welcomeMessage && this.widget?.welcomeMessage?.message && this.widget?.welcomeMessage?.message?.text != '') {
                // Igual que cuando lo manda el agente: el backend separa las
                // imagenes `![alt](url)` en un mensaje-attachment aparte y el
                // texto restante pasa por `renderRichText`. Si se renderiza todo
                // junto como Markdown, un `---` bajo el texto lo convierte en
                // titulo (<h2>) y el saludo sale en negrita gigante.
                const imagenes = [];
                const texto = this.widget.welcomeMessage.message.text
                    .replace(/!\[[^\]]*\]\(\s*([^)\s]+)[^)]*\)/g, (match, url) => {
                        imagenes.push(url);
                        return '';
                    })
                    .trim();
                if (texto != '') {
                    const rendered = helperFunctions.renderRichText(texto);
                    welcome = `
                <div class="widget_message widget_message_bot">
                    <div class="widget_message_content ${rendered.is_markdown ? 'widget_message_content_markdown' : ''}">${rendered.html}</div>
                </div>`;
                }
                for (const url of imagenes) {
                    welcome += `
                <div class="widget_message widget_message_bot">
                    <img src="${url.replace(/"/g, '&quot;')}" alt="">
                </div>`;
                }
                if (this.widget.welcomeMessage?.message?.quick_replies && this.widget.welcomeMessage?.message?.quick_replies.length > 0) {
                    welcome += `
                    <div class="widget_message_botones">`;
                    for (let boton of this.widget.welcomeMessage.message.quick_replies) {
                        // Compatibilidad: el botón puede ser un string (formato antiguo)
                        // o un objeto { buttonType, label, action }.
                        let label, type, payload;
                        if (typeof boton === 'object' && boton !== null) {
                            label = boton.label ?? boton.title ?? boton.text ?? '';
                            if (boton.buttonType === 'url') {
                                // Reutiliza el handler existente: type=web_url => window.open(payload)
                                type = 'web_url';
                                payload = boton.action ?? boton.url ?? boton.payload ?? '';
                            } else {
                                type = 'postback';
                                payload = boton.action ?? boton.payload ?? label;
                            }
                        } else {
                            label = boton;
                            type = 'postback';
                            payload = boton;
                        }
                        const safePayload = String(payload).replace(/"/g, '&quot;');
                        welcome += `<span onmouseover="this.style.backgroundColor='${this.widget.color_primary}';this.style.color='${this.widget.color_message_text}'" onmouseout="this.style.backgroundColor='white';this.style.color='${this.widget.color_primary}'" style="border-color: ${this.widget.color_primary}; color: ${this.widget.color_primary}" class="widget_message_boton" type="${type}" payload="${safePayload}">${label}</span>`;
                    }
                    welcome += `
                    </div>`;
                }
            }
            return welcome;
        }
    },
    computed: {
        //¿Se permite adjuntar archivos desde la barra de escritura?
        //Configurable en Settings → Web → Extra functionalities (metadata.allow_attach_file).
        //Los widgets creados antes de esta opción no traen la clave: por compatibilidad se permite.
        allowAttachFile() {
            const value = this.widget?.allow_attach_file;
            if (value === undefined || value === null || value === '') return true;
            return value !== 'false' && value !== false;
        },
        /**
         * ¿El agente responde SIN streaming? (`chat_settings.stream_ia` apagado).
         *
         * Lo expone la edge `/widget` en la config (metadata.stream_ia). Solo cuenta
         * el `false` EXPLICITO: el loader cachea la config del widget 24h, asi que
         * una config vieja puede no traer la clave todavia — y sin dato se mantiene
         * el comportamiento de siempre.
         */
        streamIaDesactivado() {
            return this.widget?.stream_ia === false;
        },
        //¿Es modo nativo con hero? (el hero debe ir primero, antes que el formulario)
        isNativeHero() {
            return this.widget?.layout === 'native' && this.widget?.native?.hero !== false;
        },
        viewForm() {
            //En native+hero el hero va PRIMERO: el formulario solo aparece como "gate"
            //(nativeFormGate) cuando el usuario inicia la conversación, no al cargar.
            if (this.isNativeHero) {
                return this.widget.form == 'true' && this.nativeFormGate;
            }
            //Verificamos si mostramos el chat o el formulario
            if (this.widget.form == 'true' && this.showChatWindow == false) {
                return true;
            }
            return false;
        },
        calculateHeight() {
            let height = 0;
            // En modo nativo la cabecera se oculta por CSS, así que no descontamos su alto
            if (this.widget.hide_bar_header == 'false' && this.widget.layout !== 'native') {
                height += 60;
            }
            if (this.widget.hide_bar_write == 'false') {
                height += 73;
            } else {
                height += 24;
            }
            return height + 'px';
        },
        sinBorderWindows() {
            let class_windows = "";
            if (this.widget.hide_bar_header == 'true' && this.widget.hide_bar_write == 'true') {
                class_windows = "sin_border_windows";
            }
            return class_windows;
        },
        widgetChat() {
            let class_chat = "";
            if (this.widget.fullwidth == true || this.is_mobile) {
                class_chat += ' widget_chat_full';
            }
            if (this.widget.hide_bar_header == 'true' && this.widget.hide_bar_write == 'true') {
                class_chat += " widget_chat_full_sin_border";
            }
            // Layout nativo (estilo itel): inline, sin cabecera, bot en serif, sin burbujas
            if (this.widget.layout === 'native') {
                class_chat += " widget_chat_native";
                // Landing "hero" (configurable): título + subtítulo + topics + input centrados,
                // SIN saludo del bot. Al iniciar conversación (convStarted) pasa al hilo de chat.
                if (this.widget.native?.hero !== false && !this.convStarted) {
                    class_chat += " widget_chat_native_hero";
                }
                // Branding "Generated by lovi.ai": visible solo si se activa en config
                if (this.widget.native?.show_branding) {
                    class_chat += " widget_chat_native_branded";
                }
                // Imagen al lado (estilo itel): banner a la izquierda + chat a la derecha
                if (this.widget.native_image) {
                    class_chat += " widget_chat_native_sidebanner";
                }
            }
            return class_chat;
        },
        // Variables CSS de tema para el modo nativo. Se inyectan en la raíz del widget
        // y el bloque .widget_chat_native de app.css las consume. Por empresa solo cambian
        // estos valores (viven en channel_accounts.metadata.native), nunca el código.
        nativeVars() {
            if (this.widget.layout !== 'native') return {};
            const n = this.widget.native || {};
            const fontBot = n.font_bot === 'sans'
                ? "'Inter', system-ui, -apple-system, sans-serif"
                : "'Source Serif 4', Georgia, 'Times New Roman', serif";
            // banner_width: ancho de la columna del banner lateral. Acepta número (42 -> "42%")
            // o string con unidad ("50%", "480px"). Default 42%.
            const bw = n.banner_width;
            const sideWidth = (bw === undefined || bw === null || bw === '')
                ? '42%'
                : (/^\d+(\.\d+)?$/.test(String(bw)) ? `${bw}%` : String(bw));
            return {
                '--lv-accent': n.accent || this.widget.color_primary || '#1f6feb',
                '--lv-bg': n.bg || '#faf9f7',
                '--lv-user-bubble': n.user_bubble || '#ececec',
                '--lv-font-bot': fontBot,
                '--lv-side-width': sideWidth,
            };
        },
        processedPolicyText() {
            const text = this.widget?.translations?.[this.language]?.enter_policies || 'I accept the use of my personal data as described in these policies';
            const regex = /\[([^\]]+)\]/;
            if (regex.test(text)) {
                const match = text.match(regex);
                const linkText = match[1];
                const replacedText = text.replace(
                    regex,
                    `<a href="${this.widget.form_policy}" target="_blank" style="color:${this.widget.color_primary}">${linkText}</a>`
                );
                return replacedText;
            }
            return text;
        }
    },
    async created() {
    },
    async mounted() {
        this.loader = true;
        // Todo el arranque va en try/finally: pase lo que pase -- un chat cerrado que
        // corta la inicializacion, un fallo de realtime, un error de red -- el indicador
        // de carga se apaga. Antes cualquier `return` o excepcion de este hook lo dejaba
        // girando para siempre, y en el build de produccion sin ningun error visible.
        try {
            //Obtenemos los datos del cliente
            await this.get_data_cliente();
            //Si es layout nativo, cargamos las fuentes (serif tipo Claude)
            if (this.widget?.layout === 'native') {
                this.injectNativeFonts();
            }
            //Actualizamos la cabecera
            this.update_visual_widget();
            //Obtenemos el agente principal
            await this.get_data_agent();
            //Ejecutamos un set interval hasta detectar el elemento con id chatBody y luego paramos el interval
            this.tools_window_wiget();
            //Ponemos el welcome si viene.
            //En modo nativo con landing hero+contenido (título o topics), NO mostramos el saludo
            //del bot: el hero hace de bienvenida y la conversación empieza al primer envío.
            let welcome = this.returnWelcome();
            // En modo nativo NO mostramos el saludo del bot: el hero hace de bienvenida y la
            // conversación arranca limpia al primer envío (estilo itel).
            const skipWelcome = this.widget?.layout === 'native';
            if (welcome != '' && !skipWelcome) {
                this.messages.push({
                    message: welcome,
                    created_at: new Date().toISOString()
                });
            }
            //Habilitamos el chat
            this.showchat = true;
            //Verificamos si el chat ya se cerro
            if (this.info_user?.chat_id) {
                //Hay conversación previa: no mostramos el hero, vamos directo al hilo
                this.convStarted = true;
                this.showChatWindow = true;
                const verify_chat = await this.verifyChatSupabase(this.info_user.chat_id);
                if (!verify_chat) {
                    return;
                }
                await this.iniciar_bot();
            } else {
                this.showChatWindow = false;
            }
        } catch (e) {
            console.error('[Error] fallo al inicializar el widget:', e);
        } finally {
            this.loader = false;
        }
        // Mantener token de sesion fresco (renueva si quedan <5min)
        setInterval(async () => {
            await this.ensure_session_token();
        }, 300000); // 5 min
    },
}
</script>